// extracted by mini-css-extract-plugin
export default {"root":"languageicon_root__VU7Eu"};